import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';

import { DashboardComponent } from './dashboard/dashboard.component';

const COMPONENTS = [DashboardComponent/* , LoginComponent, RegisterComponent */];
const COMPONENTS_DYNAMIC = [];

@NgModule({
    imports: [SharedModule],
    declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC]
})
export class RoutesModule {}
